module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/trucking-banner.jpg",
            "altText": "Man next to the truck"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Commercial Truck Financing")]), _vm._v(" "), _c('p', [_vm._v("Trucking Business Financing & Equipment Loans")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering Truckers everyday.")]), _vm._v(" "), _c('p', [_vm._v("\n          The Trucking Industry is the backbone and lifeblood of the U.S.\n          economy. However, truckers encounter their own set of sudden\n          financial hurdles to overcome, especially in the wake of Covid. You\n          might require the immediate purchase of new or used trucks, sudden\n          funds needed to "), _c('strong', [_vm._v("fix unplanned truck repairs")]), _vm._v(", or\n          costs to make employee payroll. Whatever the issue, American Credit\n          understands truckers and their need for immediate commercial truck\n          financing in an ever-changing world. Read on and see how\n          "), _c('strong', [_vm._v("we help truckers everyday")]), _vm._v(".\n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row align-items-center logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/nefa-logo.png",
                  "alt": "NEFA logo"
                }
              })]), _vm._v(" "), _c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/trucking-equipment-loans.jpg",
            "altText": "Truck with wood",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Instant Trucking Equipment Loans")]), _vm._v(" "), _c('p', [_vm._v("\n          Use your Trucking Equipment Loan to\n          "), _c('strong', [_vm._v("purchase any needed trucking equipment")]), _vm._v(", such as\n          long haul or local haul commercial trucks, box trucks, flat bed\n          trucks, step decks, axle trailers, dry vans, swap loaders, dumpster\n          trucks, hook lifts, bucket trucks sleeper cabs, reefer trucks, yard\n          switchers & more! "), _c('br'), _c('br'), _vm._v("\n          American Credit understands the difficulties trucking business\n          owners face. We work with you to understand your unique trucking\n          equipment needs, and then "), _c('strong', [_vm._v("secure quick funding")]), _vm._v(" so\n          you can get back to work.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/trucking-working-capital.jpg",
            "altText": "Garbage Truck"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Trucking Working Capital Solutions")]), _vm._v(" "), _c('p', [_vm._v("\n          Need help meeting employee payroll? Need quick financing due to\n          unexpected trucking maintenance costs or supply chain disruptions?\n          American Credit can\n          "), _c('strong', [_vm._v("fix any short-term or long-term financial difficulties")]), _vm._v("\n          you are facing. Call us to find out what working capital options are\n          available to fix any situation your trucking business faces.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Commercial Truck Financing - Business Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f3a263"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/commercialTruckFinancing.vue
// module id = 1920
// module chunks = 5